import * as yup from 'yup';

const validationSchema = (intl) =>
  yup.object().shape({
    email: yup
      .string('')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        intl.formatMessage({ id: 'validation.email' })
      )
      .required(intl.formatMessage({ id: 'validation.required' })),
    password: yup
      .string('')
      .min(8, intl.formatMessage({ id: 'validation.password.min_length' }, { length: 8 }))
      .matches(/[a-zA-Z]/, intl.formatMessage({ id: 'validation.password.at_least_one_letter' }))
      .matches(/\d/, intl.formatMessage({ id: 'validation.password.at_least_one_digit' }))
      .matches(
        /[^a-zA-Z0-9\s]/,
        intl.formatMessage({ id: 'validation.password.at_least_one_special_character' })
      )
      .required(intl.formatMessage({ id: 'validation.required' })),
    termsAccepted: yup
      .boolean()
      .oneOf([true], intl.formatMessage({ id: 'validation.terms_accepted' }))
      .required(intl.formatMessage({ id: 'validation.required' })),
    privacyPolicyAccepted: yup
      .boolean()
      .oneOf([true], intl.formatMessage({ id: 'validation.terms_accepted' }))
      .required(intl.formatMessage({ id: 'validation.required' })),
  });

export default validationSchema;
